import { setMaskTelefone, mascaraCEP, setMaskData } from './utils';

export const foneMask = (fone, form, name) => {
  const value = setMaskTelefone(fone);
  return form.setFields([
    {
      name,
      value,
    },
  ]);
};

export const dateMask = (date, form, name) => {
  const value = setMaskData(date);
  return form.setFields([
    {
      name,
      value,
    },
  ]);
};

export const cepMask = (e, form, nome) => {
  if (nome === 'cep') {
    return form.setFieldsValue({
      cep: mascaraCEP(e.target.value),
    });
  }
};
